import { render } from "./MedicineProductMappingIndex.vue?vue&type=template&id=4574c4d8&scoped=true"
import script from "./MedicineProductMappingIndex.vue?vue&type=script&lang=js"
export * from "./MedicineProductMappingIndex.vue?vue&type=script&lang=js"

import "./MedicineProductMappingIndex.vue?vue&type=style&index=0&id=4574c4d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4574c4d8"]])

export default __exports__